module.exports = "/remote-dist/907aacadce0bc145ff87dec197023a81.gif";